/**
 * Hook to access public runtime configuration values
 * @returns {object} The public runtime configuration object
 */
export default function useWindowConfig() {
  return window.CONFIG || {};
}
